import './styles.css';

const Component = () => {
    return (
        <>
        
        </>
    );
};

const data = {
    title: {
        ES: "Atlas",
        EN: "Atlas",
    },
    description: {
        ES: "Atlas de Radio Tango.",
        EN: "Radio Tango atlas."
    },
    noindex: true,
    href: 'atlas',
    body: <Component/>,
}

export default data;